'use client';

import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export function MarketingCTA() {
  return (
    <section className="py-20 md:py-32 px-4 relative">
      {/* Warm gradient background: ivory → warm gold glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-ivory via-[hsl(var(--gold)/0.15)] to-[hsl(var(--gold)/0.25)]" />
      
      <div className="max-w-4xl mx-auto relative z-10">
        {/* Subtle brand accent divider */}
        <div className="flex items-center justify-center mb-12">
          <div className="h-px w-16 bg-gradient-to-r from-transparent via-border/20 to-transparent" />
          <div className="mx-4 h-1 w-1 rounded-full bg-[hsl(var(--gold)/0.3)]" />
          <div className="h-px w-16 bg-gradient-to-r from-transparent via-border/20 to-transparent" />
        </div>

        <div className="text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-spectral font-semibold text-foreground mb-4">
            Ready to Get Started?
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto leading-relaxed">
            Join churches and organizations using The Way Maker to create meaningful
            connections with their communities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Link href="/m/pricing">
              <Button 
                size="lg" 
                className="text-base px-8 bg-burgundy text-white hover:bg-[hsl(var(--burgundy)/0.9)] border border-gold/40 shadow-soft hover:shadow-elegant"
              >
                View Pricing
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link href="/m/contact">
              <Button 
                size="lg" 
                variant="outline"
                className="text-base px-8 border-gold/50 bg-white/60 hover:bg-white/80 text-gold hover:text-[hsl(var(--burgundy))] hover:border-burgundy/40 shadow-none"
              >
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
